export default {
    data() {
        return {
            fixNav: false,
        };
    },

    methods: {
        // Dynamically updates classes of edit form and nav list depending on window height and content
        checkHeightOnResize() {
            let nav = document.getElementsByClassName('height-check')[0];
            let sett = document.getElementsByClassName('common-form-wrapper')[0];
            let head = document.getElementsByClassName('header-fixed-top')[0];
            let windowHeight = document.documentElement.clientHeight;
            let headH = 0;
            let navH = 0;
            let setH = 0;

            if (typeof nav === 'object') {
                navH = getComputedStyle(nav).height.split('px')[0];
            }
            if (typeof sett === 'object') {
                setH = getComputedStyle(sett).height.split('px')[0];
            }
            if (typeof head === 'object') {
                headH = getComputedStyle(head).height.split('px')[0];
            }

            const PADDING = 45;

            this.fixNav = windowHeight - headH - PADDING * 2 > navH;
            if (this.$refs.edit) {
                this.$refs.edit.isFixed = windowHeight - headH - PADDING * 3 > setH;
            }

            return true;
        },
    },
};
